import React, { useState, useRef, useEffect, useContext } from "react"; 
import "./InvesterRelation.css";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Container, Col, Row, Table } from "react-bootstrap";  
import pdf7 from "../../pdf/dummy.pdf"; 
import pdficon from "../../Images/downloadpdf.png";
import URLstateContext from "../../provider/CommonContext";
import { MdClose } from "react-icons/md";
import Assamese from "../../UploadDownloads/Assamese.zip";
import Bengali from "../../UploadDownloads/Bengali.zip";
import Gujrati from "../../UploadDownloads/Gujrati.zip";
import Hindi from "../../UploadDownloads/Hindi.zip";
import Kanada from "../../UploadDownloads/Kanada.zip";
import Kashmiri from "../../UploadDownloads/kashmiri.zip";
import Konkani from "../../UploadDownloads/konkani.zip";
import Marathi from "../../UploadDownloads/Marathi.zip";
import Oriya from "../../UploadDownloads/Oriya.zip";
import Punjabi from "../../UploadDownloads/Punjabi.zip";
import Sindhi from "../../UploadDownloads/Sindhi.zip";
import Tamil from "../../UploadDownloads/Tamil.zip";
import Telegu from "../../UploadDownloads/Telegu.zip";
import Urdu from "../../UploadDownloads/Urdu.zip";

import MCX_assamese from "../../UploadDownloads/MCX_assamese.zip";
import MCX_bengalie from "../../UploadDownloads/MCX_bengalie.zip";
import MCX_gujarati from "../../UploadDownloads/MCX_gujarati.zip";
import MCX_hindi from "../../UploadDownloads/MCX_hindi.zip";
import MCX_kannada from "../../UploadDownloads/MCX_kannada.zip";
import MCX_kashmiri from "../../UploadDownloads/MCX_kashmiri.zip";
import MCX_konkani from "../../UploadDownloads/MCX_konkani.zip";
import MCX_malayalam from "../../UploadDownloads/MCX_malayalam.zip";
import MCX_marathi from "../../UploadDownloads/MCX_marathi.zip";
import MCX_oriya from "../../UploadDownloads/MCX_oriya.zip";
import MCX_punjabi from "../../UploadDownloads/MCX_punjabi.zip";
import MCX_sindhi from "../../UploadDownloads/MCX_sindhi.zip";
import MCX_tamil from "../../UploadDownloads/MCX_tamil.zip";
import MCX_telegu from "../../UploadDownloads/MCX_telegu.zip";
import MCX_urdu from "../../UploadDownloads/MCX_urdu.zip";
 

import { format } from 'date-fns';
function Investor() {
    const { BaseLiveURL } = useContext(URLstateContext);
    //const refElement = useRef("");
    const [data, setData] = useState(false);
    const [ismonthly, setismonthly] = useState(false);
    const [typeLink, settypeLink] = useState(false);
    const [nodatafound, setnodatafound] = useState(false);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const downloadsclick = (typeLink,Type) => {
        settypeLink(typeLink);
        postData('api/Login/InvestorRelations', { Type: Type })
            .then((data) => {
               
                if (data.data != null && data.data.length > 0) { setnodatafound(false);setData(data.data); }
                else { setData(null); setnodatafound(true);}
                
            });
    }
    useEffect(() => {
        settypeLink("Policies");
        postData('api/Login/InvestorRelations', { Type: "Policies" })
            .then((data) => {
                
                if (data.data != null && data.data.length > 0) { setnodatafound(false); setData(data.data); }
                else { setData(null); setnodatafound(true); }
            });
    }, []);
    async function postData(url = '', data = {}) {
         
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }
    // const clickLanguage = () => {
    //     setShow1(true);
    // }
    // const clickLanguages = () => {
    //     setShow2(true);
    // }
    // const handleClose1 = () => setShow1(false);
    // const handleClose2 = () => setShow2(false);
    return (
        <>
            <section className="our-story-block disclaimer">
                <Container>
                    <Row>
                        <Col md={{ span: 12, offset: 0 }}>
                            <div className="our-story-inner investor-charter">
                                <h2>Investor Relations</h2>
                                <ul>
                                    <li>
                                        <a   className={typeLink === "Policies" ? "downloadbtnactive" : "cursorclass"} onClick={() => downloadsclick('Policies','Policies')}>
                                        Policies
                                        </a>
                                    </li>
                                    <li>
                                        <a className={typeLink === "Financials & Credit ratings" ? "downloadbtnactive" : "cursorclass"}  onClick={() => downloadsclick('Financials & Credit ratings','Financials & Credit ratings')}>
                                        Financials & Credit ratings
                                        </a>
                                    </li>
                                    <li>
                                        <a className={typeLink === "Intimations as per Regulations" ? "downloadbtnactive" : "cursorclass"} onClick={() => downloadsclick('Intimations as per Regulations','Intimations as per Regulations')}>
                                        Intimations as per Regulations
                                        </a>
                                    </li>
                                    <li>
                                        <a className={typeLink === "Notice of Meetings" ? "downloadbtnactive" : "cursorclass"} onClick={() => downloadsclick('Notice of Meetings','Notice of Meetings')} >
                                        Notice of Meetings
                                        </a>
                                    </li>
                                    <li>
                                        <a className={typeLink === "Press Releases" ? "downloadbtnactive" : "cursorclass"} onClick={() => downloadsclick('Press Releases','Press Releases')} >
                                        Press Releases
                                        </a>
                                    </li>
                                    <li>
                                        <a className={typeLink === "Other Submission" ? "downloadbtnactive" : "cursorclass"} onClick={() => downloadsclick('Other Submission','Other Submission')} >
                                        Other Submission
                                        </a>
                                    </li>
                                   
                                </ul>
                                 <Table bordered>

                                    <thead>
                                        <tr>
                                            {/* <td className="headingtext"> Date
                                            </td> */}
                                            <td className="headingtext">
                                                Caption
                                            </td>
                                            <td className="headingtext textcenter">
                                                Download File
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                 
                                        {data &&
                                            data.map(
                                            ({ caption, fileupload }) => (
                                                    <tr>
                                                     
                                                        <td>{caption}</td>
                                                        <td>
                                                        <a href={BaseLiveURL+ "pdf/" +fileupload} download>
                                                                <img className="imgwidth" src={pdficon} />
                                                            </a>    
                                                        </td>
                                                    </tr>
                                                 )
                                            )}
                                        {nodatafound &&
                                            <tr>
                                            <td colSpan="3" className="textcenter nodata">No {typeLink} found !!!</td>
                                            </tr>
                                            }
                                      
                                    </tbody>
                                </Table>
                                
                            </div>
                         
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}
export default Investor;
